import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import Loader from '../../Components/Utility/Loader/Loader';

function RequiredFieldModal({ onOpen, toggle, title, loading, mainContent }) {
  const { t } = useTranslation('common');

  return (
    <Modal
      show={onOpen}
      backdrop="static"
      className="custom-modal modal-medium h-800px"
      aria-labelledby={t('OPERATIONAL_CP.REQUIRE_FIELDS_MODAL.MODAL_TITLE_VCENTER')}
      onHide={toggle}
      scrollable
      size="sm"
    >
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">
            <span>{title}</span>
          </Modal.Title>
          <span onClick={toggle} className="icon-close cursor-pointer" />
        </div>
      </Modal.Header>
      <Modal.Body>
        {loading && <Loader />}
        {!loading && (
          <span className="f-14">
            {t('OPERATIONAL_CP.REQUIRE_FIELDS_MODAL.FOLLOWING_REQUIRED_TASK')}
            {mainContent?.map((mcEle) => {
              return <p key={mcEle} className="m-0 f-14">{`${mcEle?.rowName} - ${mcEle?.columnNames}`}</p>;
            })}
          </span>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default RequiredFieldModal;
